// The persistent "not a survey" line opens a short dialog (design D7). Static HTML in index.html;
// this only wires the buttons, so the line shows before any script runs.

export function attachDisclaimer(): void {
  const dialog = document.querySelector<HTMLDialogElement>("#disclaimer")!;
  document.querySelector("#disclaimer-open")!.addEventListener("click", () => dialog.showModal());
  dialog.querySelector("[data-close]")!.addEventListener("click", () => dialog.close());
}
